import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {bytesToSize} from '../../../utils/functions';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import EnImage from '../image/image.js';
import VideoPlayer from '../video/video';
import AudioPlayer from '../video/audio';
import moment from 'moment';

import Dropdown from 'react-bootstrap/Dropdown';

import './file.css';



export default class File extends React.Component {
	constructor(props) {
		super(props);
		let filename = this.props.file.filename.split('/');
		this.state = {
			server: this.props.server,
			filename: filename[filename.length-1],
			file: this.props.file,
		};
		this.imageError = this.imageError.bind(this);
		this.folderImage = this.folderImage.bind(this);
		this.download = this.download.bind(this);
	}
	async componentDidMount() {
	}

	async imageError() {
		let file = this.state.file;
		file.srcError = true;
		this.setState({file});
	}

	async folderImage() {
		return (
			<>
			</>
		)
	}
	
	async download() {
		try {
			const response = await fetch(`${this.state.server}/images/${this.state.file.filename}`);
			const blob = await response.blob();
			const blobUrl = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = blobUrl;
			link.download = this.state.file.filename.split('/').pop();
			link.click();
			URL.revokeObjectURL(blobUrl);
		} catch (error) {
			console.error('Error downloading the image:', error);
		}
	}

	render() {
		const renderFile = () => {
			switch(this.state.file.type) {
				case 'image':
					return(
						<>
							<EnImage src={this.state.file.srcError===true?'https://cloud.ultrastream.io/images/filemanager/.png':`${this.state.server}/images/${this.state.file.filename}`} onError={()=>this.imageError()} width={48} height={48} className="filemanager-icon" />
							{/*<img src={this.state.file.srcError===true?'https://cloud.ultrastream.io/images/filemanager/.png':`${this.state.server}/images/${this.state.file.filename}`} onError={()=>this.imageError()} width={48} height={48} className="filemanager-icon" />*/}
						</>
					)
				case 'audio':
					return(
						<div style={{width: '90%'}}>
							<AudioPlayer src={`${this.state.server}/images/${this.state.file.filename}`} />
						</div>
					);
				case 'video':
					return(
						<div className="video-ratio">
							<VideoPlayer
								id="video"
								//service={this.state.service.id} //{this.state.select.address}
								//select={this.state.select_temp.select}
								//uid={this.state.stage.live?.uid}
								theatre={()=>{}}
								onError={()=>{}}
								height={100}
								url={`${this.state.server}/images/${this.state.file.filename}`}
								controls={true}
								muted={false}
								autoPlay={false}
							/>
						</div>
					);
				default:
					return(
						<Link to={''}>
							<img src={this.state.file.srcError===true?'https://cloud.ultrastream.io/images/filemanager/.png':`https://cloud.ultrastream.io/images/filemanager/${this.state.file.icon}.png`} onError={()=>this.imageError()} width={48} height={48} className="filemanager-icon" alt="" />
						</Link>
					);
			}
		}

		return (
			<div className="card border custom-card shadow-none h-100">
				<div className="card-body ">
					<div className="mb-4 folder-svg-container d-flex justify-content-between align-items-top">
						{this.state.file.file === 1 ?
							<>

								<Link to={'#'} onClick={()=>this.props.chdir(this.state.filename)}>
									<img src={`https://cloud.ultrastream.io/images/filemanager/folder.png`} width={48} height={48} alt="" />
								</Link>
							</>
						:
							<>{renderFile()}</>
						}
						<div>
							<Dropdown>
								<Dropdown.Toggle variant="light" id="dropdown-basic" size="sm">
									<FontAwesomeIcon icon="bars" />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item href="" disabled={this.state.file.file===1?true:false}>Download</Dropdown.Item>
									<Dropdown.Item href="" disabled={this.state.file.file===0?true:false} onClick={()=>this.props.chdir(this.state.filename)}>Open</Dropdown.Item>
									<Dropdown.Divider />
									<Dropdown.Item href="" disabled={this.state.file.file===1?true:false} onClick={()=>this.props.rename(this.state.filename)}>Rename File</Dropdown.Item>
									<Dropdown.Item href="" disabled={this.state.file.file===1?true:false} onClick={()=>this.props.delete(this.state.filename)}>Delete File</Dropdown.Item>
									<Dropdown.Divider />
									<Dropdown.Item href="" disabled={this.state.file.file===0?true:false} onClick={()=>this.props.rename(this.state.filename)}>Rename Folder</Dropdown.Item>
									<Dropdown.Item href="" disabled={this.state.file.file===0?true:false} onClick={()=>this.props.delete(this.state.filename)}>Delete Folder</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>
					{this.state.file.file === 1 ?
						<>
							<p className="fs-14 fw-semibold mb-1 lh-1"> <Link to={'#'} onClick={()=>this.props.chdir(this.state.filename)}>{this.state.filename}</Link> </p>
							<div className="d-flex align-items-center justify-content-between flex-wrap">
								<div> <span className="text-muted fs-12">
									{/*this.state.file.folders && this.state.file.folders>0 ? <>{this.state.file.folders} Folders<br /></>:<></>}
									{this.state.file.files && this.state.file.files>0 ? <>{this.state.file.files} Files<br /></>:<></>*/}
									
									{this.state.file.folders === 0 && this.state.file.files === 0 ?
										<>Empty</>
									:
										<>{this.state.file.folders>0&&<>{this.state.file.folders} Folders, </>}{this.state.file.files} Files</>
									}
								</span> </div>
								<div> <span className="text-default fw-semibold"> {bytesToSize(this.state.file.size)} </span> </div>
							</div>
						
						</>
					:
						<>
							<p className="fs-14 fw-semibold mb-1 lh-1"> <Link to={''}>{this.state.filename}</Link> </p>
							<div className="d-flex align-items-center justify-content-between flex-wrap">
								<div> {/*<span className="text-muted fs-12"> 246 Files </span>*/} </div>
								<div> <span className="text-default fw-semibold"> {bytesToSize(this.state.file.size)} </span> </div>
							</div>
						</>
					}
				</div>
				<div className="card-footer py-1">
					<div className="d-flex align-items-center justify-content-between">
						<div className="d-flex align-items-center">
							<div className="avatar avatar-sm avatar-rounded me-2">
								<img src={`https://cloud.ultrastream.io${this.state.file.avatar}?d=?${Math.floor(Date.now()/1000)}`} alt="" />
							</div>
							<div>
								<p className="mb-0 fw-semibold">{this.state.file.title?this.state.file.title:this.state.file.username}</p>
								<p className="text-muted fs-10 mb-0">{moment(this.state.file.mtime).format("DD/MM/YYYY h:mm A")}</p>
							</div>
						</div>
						{this.state.file.file === 0 &&
							<div className="btn-list">
								<button aria-label="button" type="button" className="btn btn-icon btn-light btn-sm"><FontAwesomeIcon icon="download" onClick={()=>this.download()} /></button>
								{/*<button aria-label="button" type="button" className="btn btn-icon btn-light btn-sm"><i className="ri-thumb-up-line"></i></button>
								<button aria-label="button" type="button" className="btn btn-icon btn-light btn-sm"><i className="ri-chat-2-line"></i></button>*/}
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}
